import React from "react";
import { HeaderBar } from "../HeaderBar/HeaderBar";
import { NotificationsModal } from "../Notifications/NotificationsModal";
import { NotificationDto } from "../types/NotificationModalProps";
import { IdwalSideBar } from "../SideBar/SideBar";
import { Button } from "primereact/button";
import { MenuItem } from "primereact/menuitem";
import { FooterWithCookieConsent } from "../FooterWithCookieConsent/FooterWithCookieConsent";
import { AppSidebar, AppSidebarGroup } from "../AppSidebar/AppSidebar";
import "./ApplicationWrapper.css";

export type ApplicationWrapperProps = {
    showNotifications: boolean;
    loadingNotifications: boolean;
    mappedNotifications: Array<NotificationDto>;
    burgerMenuLogo: "main" | "presale" | "fleet" | "admin" | "id" | "id-solo";
    logoutLink: string;
    idwalSidebarIdItems: Array<MenuItem>;
    idwalSidebarOtherItems: Array<MenuItem>;
    idwalSidebarScreeningItems: Array<MenuItem>;
    children: any;
    cookieUtils: any;
    appSidebarItems: Array<AppSidebarGroup>;
    activeAppSidebarItem: string;
    markAllNotificationsAsRead: () => void;
    idwalSidebarOpen: boolean;
    setIdwalSideBarOpen: (openState: boolean) => void;
};

export const idwalSidebarIconStyle =
    "width: 22px; height: 22px; margin-right: 0.4rem; margin-left: -0.25rem";

export const ApplicationWrapper = ({
    showNotifications,
    loadingNotifications,
    mappedNotifications,
    burgerMenuLogo,
    logoutLink,
    idwalSidebarIdItems,
    idwalSidebarOtherItems,
    idwalSidebarScreeningItems,
    idwalSidebarOpen,
    cookieUtils,
    children,
    appSidebarItems,
    activeAppSidebarItem,

    setIdwalSideBarOpen,
    markAllNotificationsAsRead
}: ApplicationWrapperProps) => {
    return (
        <div className="flex flex-column min-h-screen">
            <div className="page-container flex flex-column flex-grow-1">
                <div className="fleet-header flex align-items-center justify-content-between">
                    <HeaderBar
                        burgerMenu={false}
                        logo={burgerMenuLogo}
                        className=""
                    />
                    <div className="flex flex-row-reverseheader-buttons align-items-center mr-3">
                        <IdwalSideBar
                            logoutLink={logoutLink}
                            visible={idwalSidebarOpen}
                            onClose={() => {
                                setIdwalSideBarOpen(false);
                            }}
                            idSidebarItems={idwalSidebarIdItems}
                            otherSideBarItems={idwalSidebarOtherItems}
                            screeningSidebarItems={idwalSidebarScreeningItems}
                        />
                        {showNotifications && (
                            <NotificationsModal
                                loading={loadingNotifications}
                                markAllAsRead={markAllNotificationsAsRead}
                                notifications={mappedNotifications}
                            />
                        )}
                        <Button
                            data-testid="header-burgermenu-icon"
                            className="p-button-rounded p-button-text"
                            icon="pi pi-bars"
                            onClick={() => setIdwalSideBarOpen(true)}
                        />
                    </div>
                </div>
                <section className="flex flex-grow-1">
                    <div className="flex w-full surface-ground content-border">
                        <AppSidebar
                            activeItem={activeAppSidebarItem}
                            groups={appSidebarItems}
                        />
                        <div
                            className={`block overflow-hidden w-full content-wrapper`}
                        >
                            {children}
                        </div>
                    </div>
                </section>
            </div>
            <FooterWithCookieConsent
                termsAndConditionsLink={
                    "https://www.idwalmarine.com/terms-and-conditions/idwal-id"
                }
                dataPrivacyLink={"mailto:Privacy@Idwalmarine.com"}
                enableCookies={true}
                cookieUtils={cookieUtils}
                backgroundColor={"#F4F8FB"}
            />
        </div>
    );
};
